module.exports = __webpack_public_path__ + "img/wechat.59c48365.png";